import { Button } from '@gsa/afp-component-library';
import { useNavigate, useLocation } from 'react-router-dom';
import React from 'react';
import Modal from '../../../../components/Modal/Modal';
import CommentDetail from './comment-detail';
import FvsMessages from '../../components/fvs-messages';
import { useFederalStandards } from '../../fvs-provider';
import { FVS_RT_MODAL_MODES } from '../constants';
import { useFvsRequirements } from '../requirements-provider';

const ModalTitle = () => {
  const { removeFvsMessageById, fvsMessages } = useFederalStandards();
  const { rtModalMode } = useFvsRequirements();

  let title = '';
  switch (rtModalMode) {
    case FVS_RT_MODAL_MODES.COMMENT:
      title = 'Comment';
      break;
    case FVS_RT_MODAL_MODES.CONFIRM_CANCEL:
      title = 'Confirm';
      break;
    default:
      break;
  }

  const isDeletingComment = fvsMessages.find(
    (m) => m.id === 'FVS_COMMENT' && m.message.includes('delete'),
  );

  const renderNotification = () => {
    return title === 'Comment' ? (
      <FvsMessages onClose={() => removeFvsMessageById('FVS_COMMENT')} />
    ) : null;
  };
  return (
    <div className="margin-top-8" aria-label={title}>
      {isDeletingComment ? renderNotification() : null}
      {/* eslint-disable-next-line */}
      <h3 tabIndex="0">{title}</h3>
    </div>
  );
};

const ModalContent = () => {
  const { rtModalMode } = useFvsRequirements();

  if (rtModalMode === FVS_RT_MODAL_MODES.COMMENT) {
    return (
      <>
        <CommentDetail />
      </>
    );
  }

  if (rtModalMode === FVS_RT_MODAL_MODES.CONFIRM_CANCEL) {
    return <div>Are you sure you want to cancel the comment?</div>;
  }

  return null;
};

const ModalAction = () => {
  const { rtModalMode, setFvsRequirementsContextData } = useFvsRequirements();
  const navigate = useNavigate();
  const location = useLocation();

  const onCancel = () => {
    setFvsRequirementsContextData('SET_EQUIPMENT_ASSOCIATION', null);
    setFvsRequirementsContextData('SET_RT_MODAL_MODE', null);
    navigate({ pathname: location?.pathname, search: '' });
  };

  const onCancelComment = () => {
    setFvsRequirementsContextData('SET_SELECTED_COMMENT', null);
    onCancel();
  };

  if (rtModalMode === FVS_RT_MODAL_MODES.CONFIRM_CANCEL) {
    return (
      <>
        <Button
          variant="secondary"
          onClick={onCancel}
          data-testid="standard-item-edit-cancel-btn"
          label="No"
        />
        <Button
          variant="primary"
          type="submit"
          form="standard-item-edit-form"
          data-testid="standard-item-edit-save-btn"
          onClick={onCancelComment}
          label="Yes"
        />
      </>
    );
  }

  if (rtModalMode === FVS_RT_MODAL_MODES.COMMENT)
    return (
      <>
        <Button
          variant="unstyled"
          className="margin-right-2"
          onClick={onCancel}
          data-testid="comment-modal-cancel-btn"
          label="Cancel"
        />
      </>
    );

  return null;
};

const RequirementsModalWrapper = () => {
  const { rtShowFormModal, setFvsRequirementsContextData } =
    useFvsRequirements();
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <Modal
      title={<ModalTitle />}
      actions={<ModalAction />}
      show={rtShowFormModal}
      onClose={() => {
        setFvsRequirementsContextData('SET_EQUIPMENT_ASSOCIATION', null);
        setFvsRequirementsContextData('SET_RT_MODAL_MODE', null);
        navigate({ pathname: location?.pathname, search: '' });
      }}
    >
      <ModalContent />
    </Modal>
  );
};

export default RequirementsModalWrapper;
